<div class="field field-flex compact-file">
  <label *ngIf="label">{{label}}:</label>

  <!-- Barra para agregar -->
  <div class="cf-row cf-empty"
       *ngIf="canAddMore"
       [class.disabled]="disabled"
       [class.drag-over]="isDragOver"
       (click)="triggerFileInput()"
       (dragover)="onDragOver($event)"
       (dragleave)="onDragLeave($event)"
       (drop)="onDrop($event)">
    <i class="fa-solid fa-arrow-up-from-bracket cf-up"></i>
    <span class="cf-up-text">Agregar archivos <span class="cf-hint">· o arrastra aquí ({{ totalCount }}/{{ maxFiles }})</span></span>
    <i class="fa-solid fa-circle-question cf-help" [pTooltip]="tooltip" tooltipStyleClass="custom-tooltip" [autoHide]="false"></i>
    <input type="file" #fileInput multiple [accept]="acceptedFormats" (change)="onFileSelected($event)" [disabled]="disabled" hidden />
  </div>

  <!-- Subiendo (paralelo) -->
  <div class="cf-list" *ngIf="uploadingFiles.length > 0">
    <div class="cf-row cf-uploading" *ngFor="let u of uploadingFiles; trackBy: trackByUploadId" [class.error]="u.status === 'error'">
      <i class="fa-solid cf-file-icon"
         [class.fa-spinner]="u.status === 'uploading'"
         [class.fa-spin]="u.status === 'uploading'"
         [class.fa-circle-exclamation]="u.status === 'error'"
         [class.error-icon]="u.status === 'error'"></i>
      <div class="cf-text">
        <span class="cf-name" [title]="u.name">{{ getTruncatedFileName(u.name) }}</span>
        <span class="cf-meta" *ngIf="u.status === 'uploading'">Subiendo… {{ u.progress }}%</span>
        <span class="cf-meta error-text" *ngIf="u.status === 'error'">{{ u.error || 'Error al subir' }}</span>
      </div>
      <p-progressBar *ngIf="u.status === 'uploading'" [value]="u.progress" [showValue]="false" styleClass="custom-progress cf-progress"></p-progressBar>
      <button class="cf-act danger" type="button" *ngIf="u.status === 'error'" (click)="dismissUpload(u.id)" pTooltip="Quitar" tooltipPosition="top"><i class="fa-solid fa-xmark"></i></button>
    </div>
  </div>

  <!-- Lista de archivos -->
  <div class="cf-list" *ngIf="internalFiles.length > 0">
    <div class="cf-row cf-uploaded" *ngFor="let fileUrl of internalFiles; let i = index">
      <i class="fa-solid {{ getFileIcon(getFileNameFromUrl(fileUrl)) }} cf-file-icon success"></i>
      <div class="cf-text">
        <span class="cf-name" [title]="getFileNameFromUrl(fileUrl)">{{ getTruncatedFileName(getFileNameFromUrl(fileUrl)) }}</span>
      </div>
      <div class="cf-actions">
        <button class="cf-act" type="button" (click)="onPreview(fileUrl)" [disabled]="disabled" pTooltip="Previsualizar" tooltipPosition="top"><i class="fa-solid fa-eye"></i></button>
        <button class="cf-act" type="button" (click)="onDownloadFile(fileUrl)" [disabled]="disabled" pTooltip="Descargar" tooltipPosition="top"><i class="fa-solid fa-download"></i></button>
        <button class="cf-act danger" type="button" (click)="deleteFile(fileUrl)" [disabled]="disabled" pTooltip="Eliminar" tooltipPosition="top"><i class="fa-solid fa-trash"></i></button>
      </div>
    </div>
  </div>
</div>

<!-- Toast para mensajes genéricos (errores de subida, etc.) -->
<p-toast position="top-right"></p-toast>

<!-- Toast para confirmación de eliminación -->
<p-toast position="top-center" key="confirm-delete-multi" [preventOpenDuplicates]="true">
  <ng-template let-message pTemplate="message">
    <div class="confirm-content">
      <div class="confirm-header">
        <i class="fa-solid fa-triangle-exclamation"></i>
        <span>{{ message.summary }}</span>
      </div>
      <div class="confirm-body">
        <p>{{ message.detail }}</p>
        <div class="confirm-actions">
          <button pButton type="button" label="Cancelar" class="p-button-text p-button-sm" (click)="cancelDelete()"></button>
          <button pButton type="button" label="Eliminar" class="p-button-danger p-button-sm" (click)="confirmDelete(message.data?.fileUrl)"></button>
        </div>
      </div>
    </div>
  </ng-template>
</p-toast>

<!-- Preview dialog -->
<app-file-preview-dialog
  [(visible)]="previewVisible"
  [fileUrl]="previewFileUrl"
  [fileName]="previewFileName"
  (downloadRequested)="onDownloadFile($event)">
</app-file-preview-dialog>
